import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["componentEl", "className", "children", "type", "productImage", "productName", "productBackground", "productColor", "style"];
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { componentElPropTypes } from '../customPropTypes/componentEl';
import { addClassNames, classNamePropTypes } from '../customPropTypes/classNames';
import defaultLogos from './logos-all';
import LogoFallback from '../LogoFallback';

/**
BrandSelect Item component
*/
import { jsx as _jsx } from "react/jsx-runtime";
function BrandSelectItem(_ref) {
  var Component = _ref.componentEl,
    className = _ref.className,
    children = _ref.children,
    type = _ref.type,
    productImage = _ref.productImage,
    productName = _ref.productName,
    productBackground = _ref.productBackground,
    productColor = _ref.productColor,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_brandselect__item'];
  cssClasses = addClassNames("st_brandselect__item--".concat(type), cssClasses);
  cssClasses = addClassNames(className, cssClasses);
  var styleProps = _extends({}, style);
  var ImageElement = productImage;
  var name = productName || type;
  var background = productBackground;
  var color = productColor;

  // temporary while we support type
  // we have product name, background, etc predefined in a separate object
  if (type && defaultLogos[type]) {
    var _defaultLogos$type = defaultLogos[type];
    ImageElement = _defaultLogos$type.image;
    name = _defaultLogos$type.name;
    background = _defaultLogos$type.background;
    color = _defaultLogos$type.color;
  } else if (type) {
    background = '#fff';
    color = '#000';
  }

  // set background and color of svg via inline CSS
  if (background) {
    styleProps.background = background;
  }
  if (color) {
    styleProps.color = color;
  }
  var content = children;
  if (ImageElement) {
    content = /*#__PURE__*/_jsx(ImageElement, {
      size: "none",
      className: "st_brandselect__logo"
    });
  } else if (type && !ImageElement) {
    content = /*#__PURE__*/_jsx(LogoFallback, {
      maxlen: 6,
      className: "st_brandselect__logo",
      text: productName || type
    });
  }
  return /*#__PURE__*/_jsx(Component, _extends({
    className: cssClasses.join(' '),
    "aria-label": name,
    style: styleProps
  }, otherProps, {
    children: content
  }));
}
process.env.NODE_ENV !== "production" ? BrandSelectItem.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: componentElPropTypes,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /**
   * React element with the SVG for the logo
   * Use `<SvgIcon>` to pass your own logo SVG
   */
  productImage: PropTypes.any,
  /** name of product, to be used for a11y, e.g. `Dow Jones`, `MarketWatch`, etc */
  productName: PropTypes.string,
  /** CSS background property override, e.g. `#ff0000` */
  productBackground: PropTypes.string,
  /** CSS color property override for SVG paths, if needed */
  productColor: PropTypes.string,
  /** name of product, if it already exists */
  type: PropTypes.oneOfType([PropTypes.oneOf(['wsj', 'marketwatch', 'barrons', 'fnlondon', 'pen', 'mansionglobal', 'dowjones', 'thetimes', 'wsjopinion', 'ibd', 'wsjcommerce', 'buyside', 'cwsj', 'jwsj', 'penta', 'rn']), PropTypes.string])
} : void 0;
BrandSelectItem.defaultProps = {
  componentEl: 'button',
  className: null,
  type: null,
  productName: null,
  productImage: null,
  productBackground: null,
  productColor: null
};
BrandSelectItem.displayName = 'BrandSelect.Item';
export default BrandSelectItem;